import type { Plan } from '../types'
import type { SmaugAddon, SmaugPlan } from './types'

export const planOrder: Plan[] = ['community', 'plus', 'team', 'enterprise']

export function getPlanNameFromId(planId: string, plans: SmaugPlan[]): Plan {
  const plan = plans.find((p) => p.id === planId)
  if (!plan) {
    return 'community'
  }

  const name = plan.name.toLowerCase()
  if (name.includes('community') || name.includes('pay-as-you-go') || name.includes('free')) {
    return 'community'
  }
  if (name.includes('plus')) {
    return 'plus'
  }
  if (name.includes('team')) {
    return 'team'
  }
  if (name.includes('managed')) {
    return 'managed'
  }
  if (name.includes('enterprise')) {
    return 'enterprise'
  }

  // Fallback: check metadata
  const metadata = plan.metadata ?? {}
  if (metadata['legacyName']) {
    return metadata['legacyName'] as Plan
  }

  return 'community'
}

export function formatCurrency(amount: number, currency = 'usd', decimals = 2): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(amount || 0)
}

export function getAddonPriceForPlan(addon: SmaugAddon, plan: Plan): number {
  return addon.prices[plan]?.amount ?? 0
}
